import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

import './participation.css';

const Participation = () => {
  return (
 <div className="giswnauce__participation">
        <div className="giswnauce__participation-container">
            <span className="anchor-participation" id="giswnauce_participation"></span>
            <div className="participation-container_header">
                <p><FontAwesomeIcon icon={faUserPlus} /></p><h1>Uczestnictwo</h1>
            </div>
            <div className="participation-container_subheader">
              <a href="https://forms.gle/i86yxSo5eCuSxkLD7" target="_blank" rel="noreferrer"><h3>
                Formularz zgłoszeniowy
              </h3></a>
            </div>
            <div className="participation-container_description">
              <p>Organizatorzy nie zapewniają noclegu.<br /></p>
              <p>Opłatę za konferencję należy uiścić w&nbsp;terminie maksymalnie 2&nbsp;tygodni od momentu rejestracji.</p>
              
              <h3>
                &nbsp;<br />
                W przypadku potrzeby wydłużenia terminu płatności prosimy o przesłanie informacji drogą mailową.<br />
                Faktury są przesyłane na adres e-mail podany w trakcie rejestracji.<br />
                W formularzu rejestracyjnym należy podać dane do faktury oraz wskazać, czy przed dokonaniem wpłaty ma zostać wystawiona faktura pro forma.<br />
                &nbsp;<br />
                W przypadku pracowników UWM podczas składania wniosku należy podać kod projektu:&nbsp;29.880.029-500
              </h3>

              <hr />
              <p>Opłaty konferencyjnej należy dokonać na konto:</p>
              <h2>Uniwersytet Warmińsko-Mazurski w Olsztynie</h2>
              <h3>
                ul. Michała Oczapowskiego 2<br />
                10-719 Olsztyn<br />
                Regon 510884205<br />
                NIP 7393033097<br />
                &nbsp;<br />
                Bank Millennium S.A.<br />
                15 1160 2215 1161 4000 2988 0029<br />
                W tytule przelewu należy wpisać: „Opłata konferencyjna GIS w Nauce – [Imię i nazwisko]”.<br />
                W miejsce [Imię i nazwisko] należy wpisać imię i nazwisko uczestnika, którego dotyczy opłata konferencyjna.<br />
              </h3>
            </div>
        </div> 
    </div>
  )
}

export default Participation